module.exports = __webpack_public_path__ + "static/media/17.0a8c2074.jpg";